import React from 'react';
import { useDispatch } from 'react-redux';
import FormEventHandlers from '../../../../../../libs/utility/formeventhandlers/FormEventHandlers';
import { BUTTON_TYPE } from '../../../../../components/button/constants';
import { VEC_ICON_NAME } from '../../../../../components/icons/constants';
import ConfirmationPopup from '../../../../../components/popup/confirmationpopup/ConfirmationPopup';
import { resetUserInteractionPopupWResponseObj, setTempFormFieldsList, setInitialInteractionPopupWObj } from '../../CreateFormSlice';

export default function RenderInteractionElement({interactionObj, userInteractionPopupWResponseObj}){

    const dispatch = useDispatch();

    switch(interactionObj.type){
        case 'popup':
            switch(interactionObj.runcondition){
                case 'onFormLoad':
                    return <ConfirmationPopup
                        title={"Are you sure?"}
                        bodyText={userInteractionPopupWResponseObj?.message}
                        iconName = {VEC_ICON_NAME.WARNING_ICON}
                        isOpen={(userInteractionPopupWResponseObj?.type === "popup") ? true : false}
                        confirmationButtonProps = {(userInteractionPopupWResponseObj?.positiveResponse) ? {
                            onConfirmationCb: () => FormEventHandlers.handleInitialRenderPopup(true, userInteractionPopupWResponseObj, () => dispatch(setInitialInteractionPopupWObj({}))),
                            confirmationButtonText: userInteractionPopupWResponseObj?.positiveResponse?.buttonText,
                            confirmationButtonStyles: {},
                            confirmationButtonType: BUTTON_TYPE.PRIMARY,
                        } : null}
                        cancelButtonProps = {(userInteractionPopupWResponseObj?.negativeResponse) ? {
                            onCancelCb: () => FormEventHandlers.handleInitialRenderPopup(false, userInteractionPopupWResponseObj, () => dispatch(setInitialInteractionPopupWObj({}))),
                            cancelButtonText: userInteractionPopupWResponseObj?.negativeResponse?.buttonText,
                            cancelButtonStyles: {},
                            cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                        } : null }
                        showClose={false}
                    />
                case 'onload': 
                    return <ConfirmationPopup
                        title={"Are you sure?"}
                        bodyText={userInteractionPopupWResponseObj?.message}
                        iconName = {VEC_ICON_NAME.WARNING_ICON}
                        isOpen={(userInteractionPopupWResponseObj?.type === "popup") ? true : false}
                        confirmationButtonProps = {(userInteractionPopupWResponseObj?.positiveResponse) ? {
                            onConfirmationCb: () => FormEventHandlers.handleUserInteractionPopupBtnClick(true, userInteractionPopupWResponseObj, (updatedFieldsList) => dispatch(setTempFormFieldsList(updatedFieldsList)), () => dispatch(resetUserInteractionPopupWResponseObj())),
                            confirmationButtonText: "Ok",
                            confirmationButtonStyles: {},
                            confirmationButtonType: BUTTON_TYPE.PRIMARY,
                        } : null}
                        cancelButtonProps = {(userInteractionPopupWResponseObj?.negativeResponse) ? {
                            onCancelCb: () => FormEventHandlers.handleUserInteractionPopupBtnClick(false, userInteractionPopupWResponseObj, (updatedFieldsList) => dispatch(setTempFormFieldsList(updatedFieldsList)), () => dispatch(resetUserInteractionPopupWResponseObj())),
                            cancelButtonText: "Cancel",
                            cancelButtonStyles: {},
                            cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
                        } : null }
                        showClose={false}
                    />
                default:
                    return ""
            }
            
        default:
            return ""
    }
}